import { enUS, jaJP } from "@mui/x-data-grid-premium";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useConfigStore } from "../assets/config";


export const useDataGridLocalText = () => {
  const [language] = useConfigStore((state:any) => [state.language]);
  const { t } = useTranslation();
  const localeText = useMemo(() => {
    const curLocaleText = (() => {
      if (language === 'jp') return jaJP.components.MuiDataGrid.defaultProps.localeText;
      return enUS.components.MuiDataGrid.defaultProps.localeText;
    })();
    console.log("language", language);
    if (language == "jp") {
      return {
        ...curLocaleText,
        MuiTablePagination: {
          ...curLocaleText.MuiTablePagination,
          labelRowsPerPage: language === "jp" 
    ? "ページあたりの表示数"
    : "Rows per page"
        },
        toolbarExport: 'エクスポート',
        toolbarExportPrint: 'PDFをダウンロード',
        toolbarDensity: '表示設定',
        toolbarColumns: '表示項目',
        toolbarFilters: 'フィルター',
        toolbarExportCSV: 'CSVをダウンロード',
        toolbarExportExcel: 'Excelをダウンロード',
        paginationRowsPerPage: 'ページあたりの表示数123',
        columnsPanelShowAllButton: '全てを表示',
        columnsPanelHideAllButton: '全てを非表示',
        columnsPanelTextFieldLabel: '表示項目',
        columnsPanelTextFieldPlaceholder: '表示項目を検索',
        filterPanelColumns: '項目',
        filterPanelOperator: '条件',
        filterPanelValue: '値',
        filterPanelDeleteIconLabel: '削除',
        filterPanelRemoveAllLabel: '全て削除',
        filterPanelAddFilter: 'フィルターを追加',
        filterOperatorContains: 'に以下を含む',
        filterOperatorEquals: 'が以下と等しい',
        filterOperatorStartsWith: 'が以下で始まる',
        filterOperatorEndsWith: 'が以下で終わる',
        filterOperatorIsEmpty: 'が空である',
        filterOperatorIsNotEmpty: 'が空でない',
        filterOperatorIsAnyOf: 'が以下のいずれか',
      };
    }
    
    return {
      ...curLocaleText,
      toolbarExportPrint: language == "jp"? curLocaleText?.toolbarExportPrint: 'Download as PDF',
    };
  }, [language, t]);

  return { localeText };
};
















// import { enUS, jaJP } from "@mui/x-data-grid-premium";
// import { useEffect, useState } from "react";
// import { useTranslation } from "react-i18next";
// import { useConfigStore } from "../Audit/config";

// export const useDataGridLocalText = () => {
//   const [language] = useConfigStore((state) => [state.language]);
//   const { t } = useTranslation();
//   const [localeText, setLocaleText] = useState<any>();

//   useEffect(() => {
//     const meta: Record<string, any> = {
//       en: enUS,
//       jp: jaJP,
//     };

//     // Ensure the language is valid, default to 'en' if not
//     const validLanguage = meta[language] ? language : 'en';

//     setLocaleText({
//       ...meta[validLanguage].components.MuiDataGrid.defaultProps.localeText,
//       toolbarExportPrint: t("downloadPDF"),
//     });
//   }, [language]);

//   return { localeText };
// };
